import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/elements/dialog';
import { formatDate, formatMoney } from '@/utils/format';

type RecommendedShiftsModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  day?: string;
  shifts?: any[];
};

export const RecommendedShiftsModal = ({
  open,
  setOpen,
  day = '',
  shifts = [],
}: RecommendedShiftsModalProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Recommended Shifts: {day}</DialogTitle>
          <DialogDescription>
            Based on the events on the calendar, these are the recommended shifts for this day.
          </DialogDescription>
          <div className="flex flex-col space-y-2">
            {shifts.length > 0 ? (
              shifts.map((shift, index) => (
                <div key={index} className="p-4 border rounded-md">
                  <h3 className="text-lg font-semibold">{shift.title}</h3>
                  {shift.revenue && <p>Asset Revenue: {formatMoney(shift.revenue)}</p>}
                  <p className="text-sm text-foreground/50">
                    Start: {formatDate(new Date(shift.start), 'h:mma')} - End:{' '}
                    {formatDate(new Date(shift.end), 'h:mma')}
                  </p>
                </div>
              ))
            ) : (
              <p>No recommended shifts available for this day.</p>
            )}
          </div>
        </DialogHeader>
        <div className="flex flex-col space-y-3 py-4"></div>
      </DialogContent>
    </Dialog>
  );
};
